import * as types from "../actions/actionTypes";

const initialState = {
  auth: null,
};

const generateToken = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_AUTH:
      return { ...state, auth: null };
    case types.AUTH_USER_RESPONSE:
      return { ...state, auth: action?.payload };

    default:
      return state;
  }
};

export default generateToken;
